import { createFileRoute } from "@tanstack/react-router";
import { aiaAwardsQueryOptions } from "@/lib/aia-awards.queries";
import { boardRosterQueryOptions } from "@/lib/board-snippet.queries";
import { newsQueryOptions } from "@/lib/news.queries";
import { researchProductsQueryOptions } from "@/lib/store.queries";
import { heroSlidesQueryOptions } from "@/lib/slides.queries";
import { HomepageV1 } from "./-homepages/HomepageV1";
import { BRAND } from "./-welcome/content";

/**
 * The public homepage. The customer chose the "1 · Slideshow" candidate from
 * /homepages (decision recorded Aug 31 2026), so this route renders that
 * layout directly — no version or design-direction switching. The /homepages
 * review page keeps the side-by-side switcher for reference.
 */
export const Route = createFileRoute("/welcome")({
  head: () => ({
    meta: [
      { title: "Medical Insight — Market research for the global medical aesthetic industry" },
      { name: "description", content: BRAND.short },
    ],
  }),
  loader: async ({ context }) => {
    // Warm every cache the page reads. Failures are non-fatal: each section
    // renders empty rather than blocking the page (and the prerenderer must
    // never be handed a Suspense fallback).
    await Promise.allSettled([
      context.queryClient.ensureQueryData(researchProductsQueryOptions()),
      context.queryClient.ensureQueryData(newsQueryOptions()),
      context.queryClient.ensureQueryData(heroSlidesQueryOptions()),
      context.queryClient.ensureQueryData(aiaAwardsQueryOptions()),
      context.queryClient.ensureQueryData(boardRosterQueryOptions()),
    ]);
  },
  component: WelcomePage,
});

function WelcomePage() {
  return <HomepageV1 />;
}
